import React, { useState } from 'react';
import qs from 'qs';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { func, node, object, shape, string, bool } from 'prop-types';

import { listingBridemaidsProductType, listingBrideWearProductType, listingMainProductType, listingSearchProductType, listingWeddingGuestProductType } from '../../../../config/configSearch';
import { FormattedMessage, injectIntl } from '../../../../util/reactIntl';

import Field, { hasDataInFields } from '../../Field';
import { Button, IconSpinner, Modal, NamedLink, NamedRedirect } from '../../../../components';
import BlockContainer from '../BlockContainer';

import { isScrollingDisabled, manageDisableScrolling } from '../../../../ducks/ui.duck';

import css from './BlockDefault.module.css';
import { createResourceLocatorString } from '../../../../util/routes';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { BRIDE_MAIDS, BRIDE_WEARS, CATEGORY_BRIDAL_OCCASION, CATEGORY_GOWN, CATEGORY_OCCASION, CATEGORY_WEDDING_DRESS, WEDDING_GUESTS } from '../../../../util/types';
import { createSlug, LISTING_PAGE_PARAM_TYPE_DRAFT } from '../../../../util/urlHelpers';
import { requestCreateListingDraft } from '../../../EditListingPage/EditListingPage.duck';
import { useConfiguration } from '../../../../context/configurationContext';

const BUY_NOW = 'buyNow';
const SELL_NOW = 'sellNow';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;


  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const BlockDefaultComponent = props => {
  const history = useHistory();
  const routes = useRouteConfiguration();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const state = useSelector(state => state);
  const { currentUser } = state.user || {};
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    scrollingDisabled,
    onManageDisableScrolling,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);
  const [isProductModalOpen, setIsProductModalOpen] = useState('');
  const [draftListing, setDraftListing] = useState(null);
  const [iscreateInProgress, setCreateInProgress] = useState(false);
  const [selectMainType, setSelectMainType] = useState('');
  // const { admin = false } = (currentUser && currentUser.id && currentUser.attributes.profile.privateData) || {};
  const productTypeArray = selectMainType == BRIDE_WEARS ? listingBrideWearProductType : selectMainType == BRIDE_MAIDS ? listingBridemaidsProductType : listingWeddingGuestProductType;
  const handleListingDraft = value => {
    const { productType, mainProductType } = value || {};

    setCreateInProgress(true);
    setTimeout(() => {
      const updateValues = {
        title: `Draft ${productType}`,
        publicData: {
          productType,
          mainProductType,
          productTypeFlow: { mainProductType, productType },
          updatedAt: Math.floor(Date.now() / 1000),
        },
      };
      dispatch(requestCreateListingDraft(updateValues, config)).then((result) => {
        if (result) {
          setDraftListing(result.data.data);
          setCreateInProgress(false);
        }
      });
    }, 1000);
  };

  if (draftListing && !iscreateInProgress) {
    return (
      <NamedRedirect
        name="EditListingPage"
        params={{
          id: draftListing?.id?.uuid,
          slug: createSlug(draftListing?.attributes?.title),
          type: LISTING_PAGE_PARAM_TYPE_DRAFT,
          tab: 'details',
        }}
      />
    );
  }

  const listingSellModal = (
    <Modal
      id="loginFormRequriedModal"
      isOpen={isProductModalOpen == SELL_NOW}
      onClose={() => {
        setIsProductModalOpen('');
        setSelectMainType('')
      }}
      isLandingPage={false}
      usePortal
      contentClassName={css.modalContent}
      onManageDisableScrolling={onManageDisableScrolling}
      className={iscreateInProgress ? css.productTypesModal : css.productTypesModal}
    >
      <div>
        {iscreateInProgress ? (
          <div className={css.modalProgress}>
            <IconSpinner />
            <h4 className={css.productTypesTitle}>
              <FormattedMessage id="LoginRequiredPage.loadingText" />
            </h4>
          </div>
        ) : (
          <div className={css.productTypesSell}>
            <h4 className={css.productTypesTitle}>
              <FormattedMessage id="LoginRequiredPage.sellingModalHeading" />
            </h4>
            {selectMainType ? <div className={css.productTypesWrapper}>
              {productTypeArray.map(type => {
                return (
                  <div
                    key={type.key}
                    className={css.categoriesIcon}
                    onClick={() => {
                      handleListingDraft({ productType: type.key, mainProductType: selectMainType });
                    }}
                  >
                    <div className={css.categoriesContent}>
                      <div className={css.productName}>{type.label}</div>
                      <img src={type.image} />
                    </div>

                  </div>
                );
              })}
            </div> : <div className={css.productTypesWrapper}>
              {listingMainProductType.map(type => {
                return (
                  <div
                    key={type.key}
                    className={css.categories}
                    onClick={() => {
                      setSelectMainType(type.label)
                    }}
                  >
                    <img src={type.image} />
                    <br />
                    <div className={css.productName}>{type.label}</div>
                  </div>
                );
              })}
            </div>}
          </div>
        )}
      </div>
    </Modal>
  );

  const listingProductModal = (
    <Modal
      id="loginFormRequriedModal"
      isOpen={isProductModalOpen == BUY_NOW}
      onClose={() => {
        setIsProductModalOpen('');
        setSelectMainType('');
      }}
      usePortal
      contentClassName={css.modalContent}
      onManageDisableScrolling={onManageDisableScrolling}
      className={css.productTypesModal}
    >
      <div>
        {iscreateInProgress ? (
          <div className={css.modalProgress}>
            <IconSpinner />
            <h4 className={css.productTypesTitle}>
              <FormattedMessage id="LoginRequiredPage.loadingText" />
            </h4>
          </div>
        ) :
          <div className={css.productTypesSell}>
            <h4 className={css.productTypesTitle}>
              <FormattedMessage id="LoginRequiredPage.modalHeading" />
            </h4>
            {selectMainType ? <div className={css.productTypesWrapper}>
              {productTypeArray.map(type => {
                return (
                  <div
                    key={type.key}
                    className={css.categoriesIcon}
                    onClick={() => {

                      const getDisplayProductType = (productType) => {
                        if (productType == CATEGORY_WEDDING_DRESS) return CATEGORY_GOWN;
                        if (productType == CATEGORY_BRIDAL_OCCASION) return CATEGORY_OCCASION;
                        return productType;
                      };

                      // if (admin) {
                      history.push(
                        createResourceLocatorString('AlgoliaSearchTypePage', routes, {
                          type: getDisplayProductType(type.label),
                          mainType: selectMainType.replace(/\s+/g, '-'),
                        }, {})
                      );

                      // } else {
                      //   history.push(
                      //     createResourceLocatorString('AlgoliaSearchProductTypePage', routes, {
                      //       type: getDisplayProductType(type.label),
                      //     }, {})
                      //   );
                      // }
                    }}
                  >
                    <div className={css.categoriesContent}>
                      <div className={css.productName}>{type.label}</div>
                      <img src={type.image} />
                    </div>

                  </div>
                );
              })}
            </div> :
              <div className={css.productTypesWrapper}>
                {listingMainProductType.map(type => {
                  return (
                    <div
                      key={type.key}
                      className={css.categories}
                      onClick={() => {
                        // if (type?.label == BRIDE_WEARS && !admin) {
                        //   return setSelectMainType(type.label)
                        // }
                        // else if (admin) {
                        return setSelectMainType(type.label)
                        // };
                      }}
                    >
                      <img src={type.image} />
                      <br />
                      <div className={css.productName}>{type.label}</div>
                      {/* {(type.label == BRIDE_MAIDS) ? <div className={css.hoverContent}>
                        <div>
                          <h4>
                            <FormattedMessage id="LoginRequiredPage.bridesmaidComingSoon" />
                          </h4>
                          <p>
                            <FormattedMessage id="LoginRequiredPage.bridesmaidComingSoonDescription" />
                          </p>
                          <NamedLink name="LoginRequiredPage" className={css.shopBtn}>
                            <FormattedMessage id="LoginRequiredPage.bridesmaidComingSoonButton" />
                          </NamedLink>
                        </div>
                      </div> : null}
                      {(type.label == WEDDING_GUESTS) ? <div className={css.hoverContent}>
                        <div>
                          <h4>
                            <FormattedMessage id="LoginRequiredPage.weddingGuestComingSoon" />
                          </h4>
                          <p>
                            <FormattedMessage id="LoginRequiredPage.weddingGuestComingSoonDescription" />
                          </p>
                          <NamedLink name="LoginRequiredPage" className={css.shopBtn}>
                            <FormattedMessage id="LoginRequiredPage.weddingGuestComingSoonButton" />
                          </NamedLink>
                        </div>
                      </div> : null} */}
                    </div>
                  );
                })}
              </div>}
          </div>}
      </div>
    </Modal>
  );
  return (
    <BlockContainer id={blockId} className={classes}>
      <FieldMedia
        media={media}
        sizes={responsiveImageSizes}
        className={mediaClassName}
        options={options}
      />

      {hasTextComponentFields ? (
        <div className={classNames(textClassName, css.text)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          {blockId == "hero-left" ? <div>
            {listingProductModal} {listingSellModal}
            <Button onClick={() => {
              setIsProductModalOpen("buyNow")
            }} className={css.shopBtn}>
              <FormattedMessage id="LandingPage.shopNow" />
            </Button>
            <Button onClick={() => {
              if (!(currentUser && currentUser?.id)) {
                history.push('/signup')
              } else {
                setIsProductModalOpen("sellNow")
              }
            }} className={css.shopBtn}>
              <FormattedMessage id="LandingPage.sellNow" />
            </Button>
            {/* <NamedLink name="LoginRequiredPage" className={css.shopBtn}>
              Sell Now
            </NamedLink> */}
          </div> : null}
          <Field data={callToAction} className={ctaButtonClass} options={options} />
        </div>
      ) : null}

      {blockId == "bridal_wear" ? (
        <>
          {listingProductModal} {listingSellModal}
          <div onClick={() => {
            [setIsProductModalOpen('buyNow'), setSelectMainType(BRIDE_WEARS)]
          }}
            className={css.hoverContent}
          >
          </div>
        </>
      ) : null}

      {(blockId == "bridesmaid") ? <>
        {listingProductModal} {listingSellModal}
        <div onClick={() => {


          [setIsProductModalOpen('buyNow'), setSelectMainType(BRIDE_MAIDS)]
        }}
          className={css.hoverContent}
        >
        </div>
      </> : null}
      {(blockId == "wedding_guest") ? <>
        {listingProductModal} {listingSellModal}
        <div onClick={() => {
          [setIsProductModalOpen('buyNow'), setSelectMainType(WEDDING_GUESTS)]
        }}
          className={css.hoverContent}
        >
        </div>
      </> : null}

    </BlockContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockDefaultComponent.defaultProps = {
  className: null,
  rootClassName: null,
  mediaClassName: null,
  textClassName: null,
  ctaButtonClass: null,
  title: null,
  text: null,
  callToAction: null,
  media: null,
  responsiveImageSizes: null,
  options: null,
};

BlockDefaultComponent.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // routeConfiguration: arrayOf(propTypes.route).isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const BlockDefault = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(BlockDefaultComponent);


export default BlockDefault;
